const NameToPathMap = Object.freeze({
  metrics_overview: "/admin/analyze",
  groups_create: "/admin/manage/groups",
  segments_create: "/admin/manage/segments",
  groups_calendars: "/admin/manage/calendar",
  enterprise_folders_view: "/admin/manage/folders",
  groups_budget_manage: "/admin/plan/budgeting",
  polls_create: "/admin/polls",
  users_create: "/admin/system/users/list",
  sso_authentication: "/admin/system/settings/sso",
  policy_templates_manage: "/admin/system/users/policy_templates",
  fields_manage: "/admin/system/settings/fields",
  branding_manage: "/admin/system/branding/theme",
  custom_text_manage: "/admin/system/settings/custom_texts",
  emails_manage: "/admin/system/settings/emails/layouts",
  gamification_manage: "/admin/gamification/rewards",
  logs_view: "/admin/system/logs",
  edit_posts: null,
  enterprise_manage: "/admin/system/settings/configuration",
  archives_index: "/admin/manage/archived",
  manage_fiscal_period: "/admin/plan/budgeting",
});

const NameToGlobalSettingPathMap = Object.freeze({
  enterprise_manage: "/admin/system/settings/configuration",
  fields_manage: "/admin/system/settings/fields",
  custom_text_manage: "/admin/system/settings/custom_texts",
  sso_authentication: "/admin/system/settings/sso",
  emails_manage: "/admin/system/settings/emails/layouts",
});

const GlobalSettingsPaths = Object.freeze([
  "enterprise_manage",
  "fields_manage",
  "custom_text_manage",
  "sso_authentication",
  "emails_manage",
]);

const SystemSettingsPaths = Object.freeze([
  "enterprise_manage",
  "users_create",
  "sso_authentication",
  "policy_templates_manage",
  "fields_manage",
  "branding_manage",
  "custom_text_manage",
  "emails_manage",
  "gamification_manage",
  "logs_manage",
  "edit_posts",
  "manage_fiscal_period",
]);

const GroupBudgetManagePaths = Object.freeze(["groups_budget_manage"]);

const GroupManagePaths = Object.freeze([
  "groups_create",
  "segments_create",
  "groups_calendars",
  "enterprise_folders_view",
]);

const RootManagePaths = Object.freeze([
  ...GroupManagePaths,
  "metrics_overview",
  ...GroupBudgetManagePaths,
  "campaigns_create",
  "polls_create",
  ...SystemSettingsPaths,
  "archives_index",
]);

export function resolveRootManagePath(permission) {
  const page =
    permission &&
    RootManagePaths.find((page) => permission[page] && NameToPathMap[page]);
  return page ? NameToPathMap[page] : null;
}

export function resolveGlobalSettingsManagePath(permission) {
  const page =
    permission &&
    GlobalSettingsPaths.find(
      (page) => permission[page] && NameToGlobalSettingPathMap[page],
    );
  return page ? NameToPathMap[page] : null;
}
